module.exports = __webpack_public_path__ + "static/img/diease-right.f2865119.png";